import React from 'react';
import {HomeGameCardItem} from '../home.type';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
// import LazyImage from '@/components/basic/image';
import {Image} from 'antd-mobile';
import theme from '@/style';

interface GameCardProps {
  item: HomeGameCardItem;
  screenWidth: number;
  onPress?: (item: HomeGameCardItem) => void;
}

export const GameCard: React.FC<GameCardProps> = ({
  item,
  screenWidth,
  onPress,
}) => {
  return (
    <NativeTouchableOpacity
      onPress={() => onPress && onPress(item)}
      style={[
        theme.borderRadius.m,
        theme.overflow.hidden,
        {
          height: (screenWidth * 156) / 375,
          minWidth: '25%',
          flex: 1,
          backgroundColor:
            item.categoryId === -9999
              ? 'rgba(0,0,0,0)'
              : theme.backgroundColor.palegrey,
        },
      ]}>
      {item.categoryId !== -9999 && (
        <Image
          src={item.otherUrl || item.gamePic}
          width={'100%'}
          height={'100%'}
          fallback={<div className="size-full bg-image" />}
        />
      )}
    </NativeTouchableOpacity>
  );
};
